import { BrowserRouter, Routes, Route } from 'react-router';
import ScrollToTop from './components/ScrollToTop.js';
import Home from "./Home.js";
import Header from "./components/header/head.jsx";
import Footer from "./components/Footer";
import AboutUs from './pages/AboutUs.js';
import Contact from './pages/Contact.js';
import Media from './pages/Media.js';
import Testimonial from './pages/Testimonial.js';
import { projects } from './assets/projects';
import Properties from './projects/Properties.jsx';
import LocationPage from './projects/LocationPage.jsx';
import PropertyListing from './projects/SingleListing.jsx';
import WhatsappButton from './chat/WhatsappButton.js';

// Get unique locations
const locations = [...new Set(projects.map(product => product.location))];

const App = () =>{
  return(
    <>
      <BrowserRouter>
      <ScrollToTop />
      <Header locations={locations} />
        <Routes>
          <Route path='/' element={<Home />} />
          {locations.map(location => (
          <Route 
            key={location}
            path={`/locations/:location`}
            element={<LocationPage />}
          />
        ))}
        <Route path = '/property/:productId' element = {<PropertyListing />}>
        </Route>

        <Route path = "/Properties" element = {<Properties/>}>        </Route>
        <Route path = "/AboutUs" element = {<AboutUs/>}>        </Route>
        <Route path = "/Contact" element = {<Contact/>}>        </Route>
        <Route path = "/Media" element = {<Media/>}>        </Route>
        <Route path = "/Testimonials" element = {<Testimonial/>}>        </Route>

        </Routes>
        <WhatsappButton />
        <Footer />
      </BrowserRouter>
     
    </>
  );
}
export default App;
